import { Button, Wrapper } from "nystem-components";

const SelectButton = ({ model, setValue, value }) => {
  const { trueState, trueOnState, falseState, btnType, falseOnState } = model;

  const handleChange = () =>
    setValue(trueOnState === value ? falseState || undefined : trueState);

  let { text } = model;
  let type = false;

  if (trueOnState === value) {
    ({ text } = model);
    type = btnType;
  } else if (falseOnState === value) {
    text = model.falseText;
    type = model.falseBtnType;
  }

  return btnType ? (
    <Button type={type} className={model.className} onClick={handleChange}>
      {text || "..."}
    </Button>
  ) : (
    <Wrapper className={model.className} onClick={handleChange}>
      {text || "..."}
    </Wrapper>
  );
};

export default SelectButton;
